const ScrollKeys = [32, 33, 34, 35, 36, 37, 38, 39, 40]

export class DisableScroll {
  callback
  element

  constructor (callback) {
    this.callback = callback
    this.element = document.scrollingElement
  }

  on () {
    document.addEventListener('wheel', this.handleWheel)
    document.addEventListener('touchmove', this.handleWheel)
    document.addEventListener('scroll', this.handleScroll)
    document.addEventListener('keydown', this.handleKeydown)
  }

  off () {
    document.removeEventListener('wheel', this.handleWheel)
    document.removeEventListener('touchmove', this.handleWheel)
    document.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('keydown', this.handleKeydown)
  }

  handleWheel = (e) => {
    e.preventDefault()
    if (this.callback) {
      this.callback()
    }
  }

  handleScroll = () => {
    if (this.element.scrollTop < 1200) {
      window.scrollTo(0, 0)
      if (this.callback) {
        this.callback()
      }
    }
  }

  handleKeydown = (e) => {
    if (ScrollKeys.includes(e.keyCode)) {
      e.preventDefault()
    }
    if (this.callback) {
      this.callback()
    }
  }
}
